import {UserRepository} from '../repository/UserRepository';
import {CreateUserRequest, DashboardUser} from '../models/user.model';
import {AppError, ErrorType} from '../../../Data/config/AppError';

export class CreateUserUseCase {
  private readonly userRepository: UserRepository;

  constructor (userRepository: UserRepository) {
    this.userRepository = userRepository;
  }

  async execute (userData: CreateUserRequest): Promise<DashboardUser> {
    // Validate required fields
    if (!userData.username || !userData.email || !userData.password || !userData.roleId) {
      throw new AppError('الحقول المطلوبة مفقودة: اسم المستخدم، البريد الإلكتروني، كلمة المرور، والدور مطلوبة', ErrorType.VALIDATION);
    }

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(userData.email)) {
      throw new AppError('تنسيق البريد الإلكتروني غير صحيح', ErrorType.VALIDATION);
    }

    // Validate password strength
    if (userData.password.length < 8) {
      throw new AppError('كلمة المرور يجب أن تكون 8 أحرف على الأقل', ErrorType.VALIDATION);
    }

    // Validate username format (alphanumeric and underscores only)
    const usernameRegex = /^[a-zA-Z0-9_]+$/;
    if (!usernameRegex.test(userData.username)) {
      throw new AppError('اسم المستخدم يمكن أن يحتوي على أحرف وأرقام وشرطات سفلية فقط', ErrorType.VALIDATION);
    }

    try {
      // Create the user
      const newUser = await this.userRepository.createUser(userData);

      return newUser;
    } catch (error) {
      // Don't handle error here - just throw it so it can be handled at the component level
      if (error instanceof AppError) {
        throw error;
      }
      throw AppError.fromApiError(error);
    }
  }
}
